import React, { Fragment, useState, useEffect } from "react";
import { compose, graphql } from 'react-apollo';
import { Spin } from "antd";
import AntTable from "../../common/Table"; 
import { removeVoucherM } from "../../../graphql/mutation/voucher";
import columns from "../../../const/columns/vouchers";
import { openNotificationWithIcon } from "../../common/Notification";
import routes from "../../../const/routes";
import RefreshButton from "../../common/RefreshButton";
import { formatDateTimeBR } from "../../../functions/formatDate";
import VoucherModal from "./components/VoucherModal";

function Vouchers({props, removeVoucher}){
    let [ vouchers, setVouchers ] = useState([]);
    let [ loading, setLoading ] = useState(false);
    let [ visible, setVisible ] = useState(false); 
    let [ idVoucher, setIdVoucher ] = useState(undefined); 
 
 
    async function deleteF(id){
        let body = {
            _id: id,
            removeVoucher 
        };
    
        await props.REMOVE_VOUCHER(body);

        let newVouchers = vouchers.slice();
        newVouchers = newVouchers.filter(voucher => {
            if(voucher._id !== id) return voucher
            else return null
        })
        setVouchers(vouchers = newVouchers);


        setTimeout(() => {props.refetch()},10)
        openNotificationWithIcon('success', "Sucesso", "Voucher deletado com sucesso", "", 7);
    }

    function update(id){
        localStorage.setItem('@Ossel:Update', true);
        localStorage.setItem('@Ossel:UpdateID', id);
    }

    function refresh(){
        setLoading(loading = true);
        setTimeout(() => {
            setLoading(loading = false);
            props.refetch();
        }, 1000);
    }

    function getVouchers(){
        let vouchersDB = [];
        
        props.vouchers.map(voucher => {
            vouchersDB.push({   
                _id: voucher._id,
                voucher: voucher.voucher,
                beginDate: formatDateTimeBR(voucher.beginDate),
                endDate: formatDateTimeBR(voucher.endDate),
                room: voucher.room_info[0].name,
                branch: voucher.room_info[0].branch_info[0].name
            });
            return null
        })
        
        if(vouchersDB.length > 0) setVouchers(vouchers = vouchersDB);
    }

    useEffect(() => {
        getVouchers()
    }, [props.vouchers]);
    
    function showVoucherModal(id){
        setIdVoucher(idVoucher = id);
        setTimeout(() => {setVisible(visible = true)},5)
    }

    return(
        <Fragment> 
            <RefreshButton clickAction={refresh}/>
            <VoucherModal visible={visible} setVisible={setVisible} idVoucher={idVoucher}/>
            <Spin spinning={loading}>
                <AntTable 
                    dataSource={vouchers} 
                    columns={columns} 
                    new={routes.VOUCHERS_FORM} 
                    delete={deleteF} 
                    update={update}
                    btEdit={false}
                    hideBtnNew={false}
                    btViewVoucher={true}
                    showVoucherModal={showVoucherModal}
                />
            </Spin>
        </Fragment>
    )
}

export default compose(
    graphql( removeVoucherM, { name: "removeVoucher" } )
)(Vouchers);


// WEBPACK FOOTER //
// ./src/components/general/vouchersWrapper/Vouchers.jsx